import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useBeehiivConfigurationQuery = createQueryHook(
  CreatorIntegrationsApiClient.getBeehiivConfiguration,
  {
    queryKey: ['beehiivConfiguration'],
  },
)
